import { Link, useNavigate } from "react-router-dom";
import "../styles/css/admin-style.css";
import "../styles/css/error.css";

const NotFoundPage = () => {
    const navigate = useNavigate();
    return (
        <body id="page-top" className="error">

        <div className="errorLogo">
            <img src="/logo/logo.svg" alt="Barreca Logo" className="logo"/>
        </div>

        <div className="errorDiv">
            <div>
                <h2>Oops!</h2>
            </div>
            <div>
                <p>
                    No page was found. Please use the button below to return to the home page.
                </p>
            </div>
            <div>
                <button
                    type="button"
                    className="btn-error btn-lg btn-block error-btn"
                    onClick={() => navigate("/")}
                >
                    Home
                </button>
            </div>
        </div>


        </body>
    );
};

export default NotFoundPage;
